import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fill}}`}</style>
      </defs>
      <g id="prefix__Objects">
        <g id="prefix__Designed_by_Freepik" data-name="Designed by Freepik">
          <g id="prefix__Group_2015" data-name="Group 2015">
            <path
              id="prefix__Path_5500"
              data-name="Path 5500"
              className="prefix__cls-1"
              d="M40.11 30.33a.93.93 0 00-.93.93v8.23a2.78 2.78 0 01-2.77 2.78h-26a2.79 2.79 0 01-2.78-2.78V15.34a2.78 2.78 0 012.78-2.77h8.23a.93.93 0 00.93-.92.93.93 0 00-.92-.93h-8.23a4.64 4.64 0 00-4.63 4.63v24.14a4.64 4.64 0 004.63 4.63h26A4.64 4.64 0 0041 39.49v-8.23a.93.93 0 00-.92-.93z"
            />
            <g id="prefix__Group_2010" data-name="Group 2010">
              <g id="prefix__Group_2009" data-name="Group 2009">
                <path
                  id="prefix__Path_5501"
                  data-name="Path 5501"
                  className="prefix__cls-1"
                  d="M43.35 8.12a2.93 2.93 0 010 4.15l-1.24 1.25L36.58 8l1.24-1.25a3 3 0 014.15 0z"
                />
                <path
                  id="prefix__Path_5502"
                  data-name="Path 5502"
                  className="prefix__cls-1"
                  d="M40.44 15.17L23.3 32.31l-5.52-5.53L34.92 9.65z"
                />
                <path
                  id="prefix__Path_5503"
                  data-name="Path 5503"
                  className="prefix__cls-1"
                  d="M16.67 29l4.42 4.42L15 35.11z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
